import React, { Component } from 'react';
import { dispatch, connect } from 'react-redux';
import {  Button } from 'react-bootstrap';
import { clearUser} from '../actions/creators';
import { Modal } from 'react-bootstrap';
require('es6-promise').polyfill();
require('isomorphic-fetch');



class ReviewDocument extends Component {

    constructor(props) {
        super(props);
        this.state = {
            url:'',
            loading:true,
            modalContent:'',
            redirectToLogin:false,
            status:''
        };
        if(this.props.returnStatus == "INPROGRESS"){
            this.state.status = "PENDING your EFAST2 signature";
        }

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.btnTapped=this.btnTapped.bind(this);
        this.myFunction=this.myFunction.bind(this);
    }

    componentDidMount() {
        var url = this.props.serverUrl+'/v1/document-download/fetchDocumentMetaData?intuit_apikey=preprdakyresHjYaHW1MEBflTsUGE3wXYPFbG4AM';
        document.body.style.cursor='wait';
        fetch(
            url,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method:"POST",
                responseType: 'blob',
                body:JSON.stringify({
                    email: this.props.email,
                    year: this.props.year,
                    planId:this.props.planId,
                    planEin:this.props.planEin,
                    returnStatus: this.props.returnStatus,
                    documentName: this.props.documentName,
                    taxReturnId: this.props.taxReturnId,
                    token: this.props.token,
                    realmId: this.props.realmId
                })
            }
        )
            .then(response => {
                let clone = response.clone();
                if (response.ok) {

                    document.body.style.cursor='default';
                    clone.json().then(json => {
                        var i;
                        for(i =0;i<json.document.length;i++){
                            var documentName = json.document[i].documentName;
                            this.myFunction(documentName, i+1);
                        }
                    });
                }
            })
            .catch(error => {
                this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
                this.handleShow();
            });


    }

    myFunction(documentName, docId) {
        var temp = document.getElementById("download-button");
        var docName = documentName;
        var id = docId;
        var btn = document.createElement("BUTTON");
        btn.innerHTML=documentName;
        btn.className="button";
        btn.style.textDecoration = "underline";
        btn.class = "button";
        temp.appendChild(btn);
        btn.onclick = function (){
           this.btnTapped(docName, id);
        }.bind(this);


    }

    async parseResponse(response) {
        var responseText = '';
        await response.text().then(function (data) {
            responseText = data;
            return data;
        });

        if (responseText == "Token mismatch found") {
            this.setState({modalContent: "Token has expired. Kindle login again!",redirectToLogin:true});
        }

        if (response.status == "500") {
            this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
        }
        this.handleShow();
        return responseText;
    }

     btnTapped(docName, docId) {
        var url = this.props.serverUrl+'/v1/document-download/returnDocument?intuit_apikey=preprdakyresHjYaHW1MEBflTsUGE3wXYPFbG4AM';
        document.body.style.cursor='wait';
        fetch(
            url,
            {
                headers: {
                    'Content-Type': 'application/json'
                },
                method:"POST",
                responseType: 'blob',
                    body:JSON.stringify({
                    email: this.props.email,
                    year: this.props.year,
                    planId:this.props.planId,
                    planEin:this.props.planEin,
                    returnStatus: this.props.returnStatus,
                    documentName: this.props.documentName,
                    taxReturnId: this.props.taxReturnId,
                    token: this.props.token,
                    realmId: this.props.realmId,
                    documentName: docName,
                    documentId:docId
                })
            }
        )
            .then(response => {
                let clone = response.clone();
                if (response.ok) {
                    return response.blob();
                }else {
                    document.body.style.cursor='default';
                    var responseText = this.parseResponse(clone);
                    return responseText;
                }
            })
            .then(blob => {
                if(blob != "Token mismatch found") {
                    const file = new Blob(
                        [blob],
                        {type: 'application/pdf'});
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        document.body.style.cursor = 'default';
                        window.navigator.msSaveOrOpenBlob(blob, "return.pdf");
                    } else {
                        var objectUrl = URL.createObjectURL(file);
                        window.open(objectUrl);
                        document.body.style.cursor = 'default';
                    }
                }
            })
            .catch(error => {
                this.setState({modalContent: "Something went Wrong. Kindly try again later!"});
                this.handleShow();
            });
    }

    handleShow() {
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
        if(this.state.redirectToLogin == true){
            this.props.clearUser(this.state);
        }
    }


    render() {

        console.info(this.state.url);



                return (

                    <div>
                        <font size="5" color="green"><b>Status:</b></font>
                        <font size="4">   {this.state.status}</font><br /><br />
                        <font size="5" color="green"><b>Plan:</b></font><br /><br />
                        <table>
                            <tbody>
                            <tr >
                                <td className="right">TAXYEAR:</td>
                                <td className="left">{this.props.year}</td>
                            </tr>
                            <tr>
                                <td className="right">ID:</td>
                                <td className="left">{this.props.planId}</td>
                            </tr>
                            <tr>
                                <td className="right">EIN:</td>
                                <td className="left">{this.props.planEin}</td>
                            </tr>
                            </tbody>
                        </table>
                        <br />
                        <font color="#87ceeb" size="3">Please save the PDF locally if you need more than 30 minutes for review.
                            If the session expires, first review the saved PDF, then sign in again to submit your response.
                        </font><br /><br />
                        <font size="5" color="green"><b>Review Documents:</b></font><br />
                        <div id="download-button">
                        </div>

                        <Modal show={this.state.show} onHide={this.handleClose} animation={false}>

                            <Modal.Body>{this.state.modalContent}</Modal.Body>
                            <Modal.Footer>
                                <div className="col-md-12 text-center">
                                    <Button variant="secondary" bsClass="close-button" onClick={this.handleClose}>
                                        Close
                                    </Button>
                                </div>

                            </Modal.Footer>
                        </Modal>
                    </div>


                );
            }
}

const mapStateToProps = ( state ) => {

    return {
        userName:state.userName,
        email:state.email,
        login:state.login,
        planEin:state.planEin,
        planId:state.planId,
        year:state.taxYear,
        token:state.token,
        realmId:state.realmId,
        documentName:state.documentName,
        taxReturnId:state.taxReturnId,
        returnStatus:state.returnStatus,
        serverUrl:state.serverUrl,
        documentList:state.documentList
    }

};


const mapDispatchToProps = dispatch => {
    return {
        clearUser: (state) => {
            dispatch(clearUser(state))
        }

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewDocument);
